<div class="control-defect-item" [class.compliant]="defectDto.compliance" data-testid="control-defect-item">
  <div class="defect-select-control flex-center">
    <mat-checkbox
      [disabled]="defectDto.compliance"
      [checked]="defectDto.compliance || selected"
      class="example-margin"
      (change)="onCheckboxChange()"
    ></mat-checkbox>
  </div>
  <div class="defect-image flex-center">
    <mat-icon>description</mat-icon>
  </div>
  <div class="defect-details">
    <p class="defect-description">{{ defectDto.description }}</p>
    @if (defectDto.compliance?.date; as complianceDate) {
    <div class="flex-items-center defect-deadline" data-testid="compliance-date">
      <mat-icon>task_alt</mat-icon>{{ complianceDate | date : 'dd.MM.yyyy' }}
    </div>
    } @else { @if (defectDto.deadline; as deadline) {
    <div class="flex-items-center defect-deadline" data-testid="compliance-deadline">
      <mat-icon>schedule</mat-icon>{{ deadline | date : 'dd.MM.yyyy' }}
    </div>
    } }
  </div>
  <button (click)="toggleDetails()" class="defect-display-control flex-center">
    <mat-icon>visibility</mat-icon>
  </button>
</div>
@if (defectDto.compliance) {
<sibat-control-defect-compliance-details
  data-testid="control-defect-compliance-details"
  [compliance]="defectDto.compliance"
  [controlId]="controlId"
></sibat-control-defect-compliance-details>
} @if (isOpen) {
<sibat-edit-defect
  data-testid="edit-defect"
  [defect]="editDefect"
  [thumbnails]="thumbnails"
  [isReadOnly]="true"
  [controlId]="controlId"
></sibat-edit-defect>
}
